(ns ui.register
  "Register for all UI parts."
  (:require [parts.replicant.basic]
            [app.agenda.register :as agenda]
            [ui.animation-editor.register :as animation-editor-register]
            [ui.gallery.register :as gallery-register]
            [ui.upload-status :as upload-status]
            [ui.sticker-dialogs.register :as sticker-dialogs-register]
            [app.bulk.register :as bulk]
            [ui.calendar.page]
            [app.connect-link.register :as connect-link]
            [app.team.register :as team]
            [app.api-credential.register :as api-credential]
            [app.toolbox.register :as toolbox]
            [app.api-webhook.register :as api-webhook]
            [ui.wallet.register :as wallet-register]
            [ui.mcp.register :as mcp-register]
            [ui.agent.register :as agent-register]
            [ui.cli.register :as cli-register]
            [ui.hyperframes-templates.register :as hyperframes-templates-register]
            [ui.captions.register :as captions-register]
            [app.tiktok-posting.register :as tiktok-posting]
            [app.reels.ui-register :as reels-register]
            [app.youtube-posting.register :as youtube-posting]
            [app.social-scheduling.register :as social-scheduling]
            [app.bundle-social.register :as bundle-social]
            [storrito.connect3.core]
            [storrito.connect3.info-panel]
            [ui.subscription.page]
            [ui.subscription.change-plan]
            [ui.subscription.cancel-modal]
            [ui.subscription.credits-modal]
            [ui.subscription.exit-modal]
            [ui.subscription-statement.page]
            [ui.totp.page]
            [ui.totp.new]
            [ui.totp.relation]
            [ui.elevenlabs.page]
            [ui.elevenlabs.voice-list]
            [ui.elevenlabs.generate-speech]
            [ui.dall-e.page]
            [ui.dall-e.modal]
            [ui.blackforest.modal]
            [ui.openrouter.actions]
            [ui.openrouter.modal]
            [ui.instagram-connect.page]
            [ui.instagram-connect.account-modal]
            [ui.social-account.connect-modal]
            [ui.editor2.timeline]
            [ui.editor2.common :as editor2.common]
            [ui.action-handlers]
            [ui.editor2.giphy]
            [ui.editor2.modal-music]
            [ui.editor2.sidebar-emojies]
            [ui.editor2.unsplash]
            [parts.replicant.command-query]
            [ui.editor2.modal-exit]
            [ui.editor2.modal-download]
            [ui.legacy-subscription.page]
            [ui.storrito-api.page]
            [ui.story-publish.page]
            [ui.preferences.page]
            ))

(def register
  (concat
    [

     ;; pages:
     ui.calendar.page/page
     ;; The old calculator page and its change-plan page are unregistered
     ;; since the wallet took over /ui/subscription (their namespaces stay
     ;; for an easy rollback: re-add the two entries here and revert the
     ;; page id and route of ui.wallet.page):
     ;; ui.subscription.page/page
     ui.subscription-statement.page/page
     ;; ui.subscription.change-plan/page
     ui.totp.page/page
     ui.totp.new/page
     ui.totp.relation/page
     ui.elevenlabs.page/page
     ui.dall-e.page/page
     ui.instagram-connect.page/page
     ui.editor2.timeline/page
     ui.legacy-subscription.page/page
     ui.storrito-api.page/page
     ui.story-publish.page/page
     ui.preferences.page/page

     ;; modals
     ui.elevenlabs.voice-list/modal
     ui.dall-e.modal/modal
     ui.elevenlabs.generate-speech/modal
     ui.blackforest.modal/modal
     ui.openrouter.modal/modal
     ui.editor2.modal-music/modal
     ui.editor2.modal-exit/modal
     ui.editor2.modal-download/modal
     ui.legacy-subscription.page/modal
     ui.legacy-subscription.page/legacy-plan-info-modal
     ui.subscription.credits-modal/modal
     ui.subscription.cancel-modal/modal
     ui.subscription.exit-modal/modal
     ui.instagram-connect.account-modal/modal
     ui.social-account.connect-modal/modal
     ]
    storrito.connect3.info-panel/register
    ui.openrouter.actions/register
    agenda/register
    animation-editor-register/register
    gallery-register/register
    upload-status/register
    sticker-dialogs-register/register
    bulk/register
    connect-link/register
    team/register
    api-credential/register
    toolbox/register
    api-webhook/register
    tiktok-posting/register
    reels-register/register
    youtube-posting/register
    social-scheduling/register
    bundle-social/register
    wallet-register/register
    mcp-register/register
    agent-register/register
    cli-register/register
    hyperframes-templates-register/register
    captions-register/register

    ui.action-handlers/action-handlers
    ui.editor2.modal-music/music-register
    ui.editor2.giphy/giphy-register
    ui.editor2.sidebar-emojies/register
    ui.editor2.unsplash/register

    (parts.replicant.basic/get-all)
    [{:ui.action-enricher/kind :event/target.files
      :ui.action-enricher/fn (fn [{:keys [ui.action/x] :as w}] ;; ui/action
                               (when (and (keyword? x)
                                          (= x
                                             :event/target.files))
                                 (-> (:replicant/js-event w)
                                     .-target
                                     .-files)
                                 ))}
     {:ui.action/kind :dom/click
      :ui.action/handler (fn [{:keys [action]}]
                           (let [[_ & args] action]
                             (.click (js/document.querySelector (first args)))))}
     {:ui.action/kind :editor2/reset-upload-input
      :ui.action/handler (fn [_]
                           (when-let [input (js/document.getElementById editor2.common/media-upload-input-id)]
                             (set! (.-value input) "")))}]
    parts.replicant.command-query/register
    storrito.connect3.core/register
    )
  )
